import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupCollectionListList } from '@shared/api/types';
import { useGroupCollectionsColumns } from './group-collections-table-columns';

interface GroupCollectionsTableProps
  extends DataTableProps<PaginatedGroupCollectionListList> {
  pageCount: number;
}

export default function GroupCollectionsTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
}: GroupCollectionsTableProps) {
  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupCollectionsColumns(),
    pageCount,
    getRowId: (row) => row.uuid,
    initialState: {
      columnVisibility: { uuid: false },
    },
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
